import * as Yup from 'yup';
import { Shape } from '../yup_types';
import { IDisputeQueues } from '../../store/disputes/disputes-interfaces';
export enum LOADING_FIELDS {
	PROVIDERS = 'provider',
	TYPE = 'type',
	EXTENSIONS = 'extensions',
	NAME = 'tabName',
	EMAIL = 'EmailRecipient',
	OPEN_ITEMS_ALERT = 'openItemsAlert',
	NEW_ITEMS_ALERT = 'newItemsAlert',
	AUTO_MATCH = 'autoMatch',
	PARTNER_ID = 'partnerId',
}

export enum LOADING_FIELDS_NAMES {
	PROVIDERS = 'Provider',
	TYPE = 'Report type',
	EXTENSIONS = 'Extensions',
	NAME = 'Queue name',
	PARTNER_ID = 'Partner',
	NAME_PLACEHOLDER = 'E.g. Stripe_report_Nov_2024',
	EMAIL = 'Alert recipient',
	EMAIL_PLACEHOLDER = 'E.g. example@gmail.com',
	OPEN_ITEMS_ALERT = 'Open items alert',
	OPEN_ITEMS_ALERT_DESCRIPTION = 'Check to receive twice-daily email alerts if there are any open items remaining in the queue.',
	NEW_ITEMS_ALERT = 'New items alert',
	NEW_ITEMS_ALERT_DESCRIPTION = 'Check to receive email alerts for each new item in the queue.',
	AUTO_MATCH = 'Auto match',
	AUTO_MATCH_DESCRIPTION = 'When you select the ‘Auto Match’ option, our system automatically compares the dispute details with the transaction records. It will then attempt to find a matching transaction based on criteria like amount, date, customer information and ARN/Auth code. If a match is found, the system will automatically use this information to respond to the dispute on your behalf.\n' +
		'Please be aware that while ‘Auto Match’ can save time, it’s important to review matches carefully to ensure accuracy. Inaccurate matches could affect dispute outcomes. You always have the option to manually review and modify any matches before submission if needed.',

}

export type LoadingFieldsTypes = {
	[LOADING_FIELDS.PROVIDERS]?: string,
	[LOADING_FIELDS.EXTENSIONS]?: string,
	[LOADING_FIELDS.NAME]?: string,
	[LOADING_FIELDS.PARTNER_ID]?: string,
	[LOADING_FIELDS.TYPE]?: string,
	[LOADING_FIELDS.EMAIL]?: string,
	[LOADING_FIELDS.OPEN_ITEMS_ALERT]?: boolean,
	[LOADING_FIELDS.NEW_ITEMS_ALERT]?: boolean,
	[LOADING_FIELDS.AUTO_MATCH]?: boolean,
};

export const getValidationSchema = (): Yup.SchemaOf<LoadingFieldsTypes> => Yup.object<Shape<LoadingFieldsTypes>>().shape({
	[LOADING_FIELDS.PROVIDERS]: Yup.string(),
	[LOADING_FIELDS.TYPE]: Yup.string(),
	[LOADING_FIELDS.EXTENSIONS]: Yup.string(),
	[LOADING_FIELDS.PARTNER_ID]: Yup.string(),
	[LOADING_FIELDS.NAME]: Yup.string()
		.required('Name is required'),
	[LOADING_FIELDS.EMAIL]: Yup.string()
		.email('Invalid email address'),
	[LOADING_FIELDS.OPEN_ITEMS_ALERT]: Yup.boolean(),
	[LOADING_FIELDS.NEW_ITEMS_ALERT]: Yup.boolean(),
	[LOADING_FIELDS.AUTO_MATCH]: Yup.boolean(),
});

export const initialLoadingValues = {
	[LOADING_FIELDS.PROVIDERS]: 'Fiserv',
	[LOADING_FIELDS.TYPE]: 'default',
	[LOADING_FIELDS.EXTENSIONS]: 'csv',
	[LOADING_FIELDS.PARTNER_ID]: '',
	[LOADING_FIELDS.NAME]: '',
	[LOADING_FIELDS.EMAIL]: '',
	[LOADING_FIELDS.OPEN_ITEMS_ALERT]: false,
	[LOADING_FIELDS.NEW_ITEMS_ALERT]: false,
	[LOADING_FIELDS.AUTO_MATCH]: false,
};

export const getInitialLoadingValues = (data: IDisputeQueues): LoadingFieldsTypes => ({
	[LOADING_FIELDS.PROVIDERS]: data?.provider || '',
	[LOADING_FIELDS.EXTENSIONS]: 'csv',
	[LOADING_FIELDS.PARTNER_ID]: data.partnerId || '',
	[LOADING_FIELDS.NAME]: data.name || '',
	[LOADING_FIELDS.TYPE]: data?.type || '',
	[LOADING_FIELDS.EMAIL]: data?.emailRecipient || '',
	[LOADING_FIELDS.OPEN_ITEMS_ALERT]: data?.openItemsAlert,
	[LOADING_FIELDS.NEW_ITEMS_ALERT]: data?.newItemsAlert,
	[LOADING_FIELDS.AUTO_MATCH]: false,
});
